var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c(
        "vxe-table",
        {
          ref: "fineTable",
          attrs: { "show-overflow": "", data: _vm.subjectList },
        },
        [
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "companyAwardCode",
              title: "奖励预算编码",
            },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "year", title: "年度" },
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "companyName",
              title: "公司主体",
            },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "createName", title: "调整人" },
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "createDateAll",
              title: "调整时间",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "adjustAmount",
              title: "调整金额",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "residueAmount",
              title: "余额",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }